export enum PropostaExternaEnum {
  PROPOSTA_DECLINADA = -1,
  ERRO_INTEGRACAO = -2,
  LINK_INATIVO_EXPIRADO = -3,
  //DADOS BENEFICIARIO
  BENEFICIARIO_CONCORDO = 0,
  BENEFICIARIO_ASSOCIADO = 1,
  BENEFICIARIO_TITULAR = 2,
  BENEFICIARIO_ENDERECO = 3,
  BENEFICIARIO_BANCO = 4,
  //
  // DADOS DECLARACAO SAUDE
  CARTA_ORIENTACAO = 5,
  PERGUNTAS = 6,
  TERMO = 7,
  QUESTIONARIO = 8,
  //
  //DADOS DOCUMENTO
  DOCUMENTO = 9,
  ANALISE = 10,
  RETORNO_DOCUMENTO = 11,
  //

  VIDEO_CONFERENCIA = 12,
  RETORNO_DS = 13,

  PAGAMENTO = 14,
  ANALISE_PAGAMENTO = 15,
  RETORNO_PAGAMENTO = 16,
  CONCLUSAO = 17,
  ORIENTACAO = 18,
  ADITIVO = 19,
  REDUCAO_CARENCIA = 20,
  DOCUMENTO_FINAL = 21,
  RETORNO_OPERADORA = 22,
  RETORNO_OPERADORA_DEPENDENTES = 23,
  PAGAMENTO_CONFIRMADO = 24,

  PROPOSTA_A_VENCER = -4,
  TODAS = 71,
}

const descricao = new Map<PropostaExternaEnum, string>([
  [PropostaExternaEnum.LINK_INATIVO_EXPIRADO, 'LINK INATIVO - EXPIRADO'],
  [PropostaExternaEnum.PROPOSTA_DECLINADA, 'PROPOSTA DECLINADA'],
  [PropostaExternaEnum.BENEFICIARIO_CONCORDO, 'CONCORDA'],
  [PropostaExternaEnum.BENEFICIARIO_ASSOCIADO, 'ASSOCIADO'],
  [PropostaExternaEnum.BENEFICIARIO_TITULAR, 'TITULAR'],
  [PropostaExternaEnum.BENEFICIARIO_ENDERECO, 'ENDERECO'],
  [PropostaExternaEnum.BENEFICIARIO_BANCO, 'BANCO'],
  [PropostaExternaEnum.CARTA_ORIENTACAO, 'CARTA_ORIENTACAO'],
  [PropostaExternaEnum.PERGUNTAS, 'PERGUNTAS'],
  [PropostaExternaEnum.TERMO, 'TERMO'],
  [PropostaExternaEnum.QUESTIONARIO, 'QUESTIONARIO'],
  [PropostaExternaEnum.DOCUMENTO, 'DOCUMENTO'],
  [PropostaExternaEnum.ANALISE, 'ANALISE'],
  [PropostaExternaEnum.RETORNO_DS, 'RETORNO DS'],
  [PropostaExternaEnum.RETORNO_DOCUMENTO, 'RETORNO DOCUMENTO'],
  [PropostaExternaEnum.VIDEO_CONFERENCIA, 'VIDEO CONFERENCIA'],
  [PropostaExternaEnum.PAGAMENTO, 'PAGAMENTO'],
  [PropostaExternaEnum.ANALISE_PAGAMENTO, 'ANALISE PAGAMENTO'],
  [PropostaExternaEnum.RETORNO_PAGAMENTO, 'RETORNO PAGAMENTO'],
  [PropostaExternaEnum.CONCLUSAO, 'CONCLUSAO'],
  [PropostaExternaEnum.ORIENTACAO, 'ORIENTACAO'],
  [PropostaExternaEnum.ADITIVO, 'ADITIVO'],
  [PropostaExternaEnum.REDUCAO_CARENCIA, 'REDUCAO CARENCIA'],
  [PropostaExternaEnum.DOCUMENTO_FINAL, 'DOCUMENTO FINAL'],
  [PropostaExternaEnum.RETORNO_OPERADORA, 'RETORNO OPERADORA'],
  [PropostaExternaEnum.RETORNO_OPERADORA_DEPENDENTES, 'RETORNO OPERADORA DEPENDENTES'],
  [PropostaExternaEnum.PAGAMENTO_CONFIRMADO, 'PAGAMENTO CONFIRMADO'],
  [PropostaExternaEnum.PROPOSTA_A_VENCER, 'SETE DIAS PARA VENCER - PROPOSTA A VENCER'],
  [PropostaExternaEnum.TODAS, 'TODAS PROPOSTAS'],
]);

export class PropostaExternaEnumDescription {
  static getDescricao(valor: PropostaExternaEnum): string {
    return descricao.get(valor) || '';
  }

  static getAll(): {valor: PropostaExternaEnum; descricao: string}[] {
    return Array.from(descricao.entries()).map(([valor, descricao]) => ({
      valor,
      descricao,
    }));
  }
}
